/* Previous/Next record navigation (Design Constitution N08): one inline
   '‹ 3 of 12 ›' at every width — no fixed edge chevrons. 44px round steps
   (§3 tap targets) on the shared pop-out; the position in gray tabular
   numerals. Pages may tune spacing through their own wrappers. */
.record-sequence-nav {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0 0 8px;
}

.record-sequence-nav__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid var(--border-strong);
  border-radius: 999px;
  background: #fff;
  color: var(--ink);
  font-family: inherit;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.record-sequence-nav__button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.record-sequence-nav__chevron {
  display: block;
  margin-top: -2px;
}

.record-sequence-nav__position {
  min-width: 64px;
  text-align: center;
  color: var(--text-2);
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
